import { Modal, ModalTitle } from "react-bootstrap"
import { ReportForm } from "./ReportForm"
import i18next from "i18next"
import _ from 'lodash';

type Props = {
  isOpen?: boolean;
  closeModal?: (reload?: boolean) => void;
}

export function CreateNewReportModal({ isOpen, closeModal = _.noop }: Props) {
  return (
    <Modal
      show={isOpen}
      onHide={() => closeModal()}
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title className='display-6'>{i18next.t("create_opportunity")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ReportForm
          submitFn={() => { }}
          handleClose={closeModal}
        />
      </Modal.Body>
    </Modal>
  )
}
